import { useEffect, useState, useRef, useMemo } from 'react';
import './rowLayoutPoster.scss';
import PictureBox from '../allTypePictureBox/pictureBox/pictureBox.js';
// import Event, { EVENTS } from '../../util/event';

/**
 * Assign the project to an employee.
 * @param {Function} posterArr - 海报数组数据（必传）.
 * @param {Function} isChecked - 是否聚焦到该组件（必传）.
 * @param {Function} focusIndex - 聚焦在哪个元素上（元素索引值）（必传）.
 * @param {Function} startIdx - 数组截取的位置（元素索引值）（必传）.
 * @param {Function} moduleIdx - 所处的column位置（模块索引值）（必传）.
 * @param {Function} leaveFunction - 向上向下切换时执行的函数（参数对象{move, columnIndex}）.
 * @param {Function} isHaveHistory - 是否有history历史记录按钮（）.
 * @param {Function} addBtnPosition - 历史记录按钮的位置在左边还是右边('left' or 'right').
 * @param {Function} isHaveMore - 是否有更多按钮（）.
 * @param {Function} theShowCount - 展示海报的数量（）.
 */
export default function rowLayoutPoster(props) {
  // const { isLeave, column, focusTemporaryBox } = useContext(ModuleListInfoContext);
  const [state, updateState] = useState({
    posterArr: [],
    isChecked: false,
    focusIndex: 0,
    moduleIdx: '',
    isHaveHistory: false,
    addBtnPosition: 'left',
    isHaveMore: false,
    posterWidth: 0,
  });

  const mouseClick = useMemo(() => props.mouseClick || (() => { }), [props.mouseClick]);
  const curFocusColumnIdx = useMemo(() => props.curFocusColumnIdx || 0, [props.curFocusColumnIdx]);

  const [actionIdx, updateActionIdx] = useState('');

  const rowPosterContent = useRef(null);

  useEffect(() => {
    const {
      focusIndex,
      moduleIdx,
      isHaveHistory,
      addBtnPosition,
      isHaveMore,
      isChecked,
      actionIdx,
      posterWidth,
    } = props;


    const { posterArr } = props;
    updateState(state => ({
      ...state,
      posterArr,
      focusIndex,
      moduleIdx,
      isHaveHistory,
      addBtnPosition,
      isHaveMore,
      isChecked,
      posterWidth: (posterWidth + 36) / global.constants.rootValue,
    }));
    updateActionIdx(actionIdx);
  }, [
    props.posterArr,
    props.focusIndex,
    props.moduleIdx,
    props.isHaveHistory,
    props.addBtnPosition,
    props.isHaveMore,
    props.isChecked,
    props.actionIdx,
    props.posterWidth,
  ]);

  return (
    <div
      className='rowLayoutPoster'
      style={state.focusIndex - 3 > 0 ? { transform: `translateX(-${(state.focusIndex - 3) * state.posterWidth}rem` } : {}}
      ref={rowPosterContent}
    >
      <div className='content'>
        {state.posterArr.map((poster, index) => (
          <div
            className={
              ['rowLayout', index === state.focusIndex && state.isChecked ? 'focusable' : ''].join(' ')
            }
            data-test={`${index}${state.focusIndex}${state.isChecked}`}
            key={index}
            module_index={state.moduleIdx}
            item_index={index}
            onClick={e => mouseClick(e, index, curFocusColumnIdx)}
          >
            <PictureBox
              posterBox={{
                posterArr: {
                  ...poster,
                  isFocus: state.isChecked && index === state.focusIndex,
                },
                posterIndex: index,
                posterAnimation: actionIdx,
              }}
              isChecked={state.isChecked}
            >
            </PictureBox>
          </div>
        ))}
      </div>
      {/* <img className='prevLoad' src={prevLoadUrl}>
      </img> */}
    </div>
  );
}

